import React from "react";

export const Download = () => {

  return (
    <div className="mb-16">
      <div className="flex items-center staticBanner bg-[#cbbef0] relative">
        <div className="staticBannerContent">
          <img
            src="/images/infoBanner.png"
            alt="banner"
            className="staticBannerImg"
          />
          <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] translate-x-[59%] max-h-full">
            <h2 className="font-black text-primaryDark">下載專區</h2>
            {/* <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
                參加高雄市數位研習活動，掌握最新教學科技，提升教學智慧，讓學生學習效果更卓越！這裡專門提供教師的研習資訊，助您持續進步。
              </p> */}
          </div>
        </div>
      </div>
      
      <div className="content px-4 mx-auto pt-2">
        <div className=" mt-12 md:mt-16">
          {/* <div className="text-xl md:text-2xl font-medium text-Headline mb-6 md:mb-8">
          下載專區
          </div> */}
          <iframe src="https://affairs.kh.edu.tw/6856/upload/upload_list/9" style={{ width: '100%', height: '70vh', display: 'block', padding: '0', margin: '0' }}></iframe>
        </div>
      </div>

      {/* <div className='p-7 lg:p-16'></div> */}
    </div>
  );
};
